import Vue from 'vue';
import { mapGetters } from 'vuex';
import TopBar from 'components/TopBar.vue';
import { RESET_PASSWORD } from 'src/store/types';
import { Form, Field } from 'components/forms';
import { BfTextInput, BfButton } from 'components/Butterfly';
import 'components/forms/rules/required';
import 'components/forms/rules/passwordMatch';
import 'components/forms/rules/validPassword';
export default Vue.extend({
    components: { TopBar, Form, Field, BfTextInput, BfButton },
    computed: {
        ...mapGetters([
            'hasRequestErrors', 'serverErrors', 'validationErrors'
        ]),
        initialFormValues() {
            return {
                password1: '',
                password2: '',
            };
        },
    },
    methods: {
        async doReset({ password1, password2 }) {
            try {
                await this.$store.dispatch({
                    type: RESET_PASSWORD,
                    password1,
                    password2,
                    uid: this.$route.params.uid,
                    token: this.$route.params.token
                });
                if (this.hasRequestErrors === false) {
                    this.$router.push({ name: 'login' });
                }
            }
            catch {
                // Do nothing - request errors will be displayed
                // via this.hasRequestErrors
            }
        }
    }
});
